// TODO(ts-migration): large page entangled with untyped .js services
// (TraineeService, PlanSerice) — convert after those services are typed.
import {useNavigate, useParams} from "react-router-dom";
import Loader from "../componenets/Loader";
import NoteDialog from "../componenets/client/NoteDialog";
import {Box, Chip, IconButton, Tooltip, Typography, useTheme, useMediaQuery, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button} from "@mui/material";
import {ArrowBack, ArrowForward, NoteAdd, Settings as SettingsIcon, Add as AddIcon, Remove as RemoveIcon, DriveFileRenameOutline as RenameIcon, Assessment as OverviewIcon, LocalFireDepartment as WarmupIcon} from "@mui/icons-material";
import MobileClientWeekView from "../componenets/client/mobile/MobileClientWeekView";
import {saveClientNote, getClient} from "../services/TraineeService";
import ProgramSettingsDialog from "../componenets/client/ProgramSettingsDialog";
import ProgramWarmupDialog from "../componenets/client/ProgramWarmupDialog";
import {getErrorMessage} from "../enums/ErrorMessages";
import {useEffect, useState} from "react";
import {useMessageContext} from "../contexts/MessageContext";
import {getPlan, addWorkoutDay, removeWorkoutDay, moveWorkoutDay} from "../services/PlanSerice";
import ClientWorkoutChip from "../componenets/client/ClientWeekChip";
import RenameWorkoutDayDialog from "../componenets/client/RenameWorkoutDayDialog";
import {workoutDayLabel} from "../services/WorkoutDayNameService";
import WorkoutActiveTab from "../componenets/client/WorkoutActiveTab";
import WeekMusclesBreakdown from "../componenets/client/WeekMusclesBreakdown";

const ClientWeekPage = () => {
  const [newNote, setNewNote] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [planState, setPlanState] = useState();
  const [openIntervals, setOpenIntervals] = useState({});
  const [reloadKey, setReloadKey] = useState(0);
  const [client, setClient] = useState(null);
  const [settingsDialogOpen, setSettingsDialogOpen] = useState(false);
  const [warmupDialogOpen, setWarmupDialogOpen] = useState(false);
  const [removeWorkoutDialogOpen, setRemoveWorkoutDialogOpen] = useState(false);
  const [workoutToRename, setWorkoutToRename] = useState(null);
  const [workoutToRemove, setWorkoutToRemove] = useState(null);
  const [draggedGroupUuid, setDraggedGroupUuid] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const [recentlyMovedGroupUuid, setRecentlyMovedGroupUuid] = useState(null);

  const {notificationHandler} = useMessageContext();
  const params = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const fetchClient = () => {
    getClient(params.userId)
        .then(res => setClient(res.data))
        .catch(e => notificationHandler.error(getErrorMessage(e.response?.data?.errorCode)));
  };

  const fetchPlan = () => {
    getPlan(params.userId, params.programId)
        .then(res => setPlanState(prv => ({
          ...prv,
          plan: res.data,
          blockIdx: prv?.blockIdx ?? Number(params.blockIndex),
          weekIdx: prv?.weekIdx ?? Number(params.weekIndex),
        })))
        .catch(e => notificationHandler.error(getErrorMessage(e.response?.data?.errorCode)));
  };

  useEffect(() => {
    getPlan(params.userId, params.programId)
        .then(res => setPlanState(prv => {
          console.log(res.data);
          return {
            ...prv,
            plan: res.data,
            blockIdx: Number(params.blockIndex),
            weekIdx: Number(params.weekIndex),
          }
        }))
        .catch(e => notificationHandler.error(getErrorMessage(e.response?.data?.errorCode)));
    fetchClient();
  }, [])

  const handleNewNote = (note) => {
    const body = {
      traineeId: params.userId,
      message: note.message
    }
    saveClientNote(body)
        .then(() => setNewNote(false))
        .then(() => notificationHandler.success("פתק נשמר בהצלחה"))
        .catch(e => {
          notificationHandler.error(getErrorMessage(e.response?.data?.errorCode));
        })
  }

  const handleForward = () => {
    if (!planState?.plan?.blocks) return;

    const curBlock = planState.plan.blocks.sort((a, b) => a.index > b.index ? 1 : -1)
        .at(planState.blockIdx);

    if (!curBlock?.weeks) return;

    const curWeek = curBlock.weeks
        .sort((a, b) => a.index > b.index ? 1 : -1)
        .at(planState.weekIdx);

    if (!curWeek) return;

    const numOfWeeks = curBlock.weeks.length;
    const nomOfBlocks = planState.plan.blocks.length;

    if (curWeek.index < (numOfWeeks - 1)) {
      const nextBlockIdx = planState.blockIdx;
      const nextWeekIdx = planState.weekIdx + 1;
      setPlanState(prv => ({...prv, weekIdx: nextWeekIdx}));
      navigate(`/app/clients/${params.userId}/${params.programId}/week/${nextBlockIdx}/${nextWeekIdx}`, {replace: true});
    } else if (curBlock.index < (nomOfBlocks -1)) {
      const nextBlockIdx = planState.blockIdx + 1;
      const nextWeekIdx = 0;
      setPlanState(prv => ({...prv, blockIdx: nextBlockIdx, weekIdx: nextWeekIdx}));
      navigate(`/app/clients/${params.userId}/${params.programId}/week/${nextBlockIdx}/${nextWeekIdx}`, {replace: true});
    }
  }

  const handleBackwards = () => {
    const curBlock = planState.plan.blocks.sort((a, b) => a.index > b.index ? 1 : -1)
        .at(planState.blockIdx);

    const curWeek = curBlock.weeks
        .sort((a, b) => a.index > b.index ? 1 : -1)
        .at(planState.weekIdx);

    if (curWeek.index > 0) {
      const nextBlockIdx = planState.blockIdx;
      const nextWeekIdx = planState.weekIdx - 1;
      setPlanState(prv => ({...prv, weekIdx: nextWeekIdx}));
      navigate(`/app/clients/${params.userId}/${params.programId}/week/${nextBlockIdx}/${nextWeekIdx}`, {replace: true});
    } else if (curBlock.index > 0) {
      const nextBlockIdx = planState.blockIdx - 1;
      const sortedBlocks = planState.plan.blocks.sort((a, b) => a.index > b.index ? 1 : -1);
      const nextWeekIdx = sortedBlocks.at(nextBlockIdx).weeks.length - 1;
      setPlanState(prv => ({...prv, blockIdx: nextBlockIdx, weekIdx: nextWeekIdx}));
      navigate(`/app/clients/${params.userId}/${params.programId}/week/${nextBlockIdx}/${nextWeekIdx}`, {replace: true});
    }
  }

  const handleAddWorkoutDay = () => {
    if (!planState?.plan?.id) {
      notificationHandler.error("אין תוכנית פעילה");
      return;
    }
    setLoading(true);
    addWorkoutDay(planState.plan.id)
      .then((res) => {
        notificationHandler.success(`יום אימון נוסף בהצלחה (${res.data.weeksModified} שבועות עודכנו)`);
        fetchPlan();
      })
      .catch(e => notificationHandler.error(getErrorMessage(e.response?.data?.errorCode) || "שגיאה בהוספת יום אימון"))
      .finally(() => setLoading(false));
  };

  const handleRemoveWorkoutDay = (workout) => {
    setWorkoutToRemove(workout);
    setRemoveWorkoutDialogOpen(true);
  };

  const handleWorkoutDrop = (targetWorkout) => {
    if (!draggedGroupUuid || !planState?.plan?.id || !targetWorkout) return;
    if (draggedGroupUuid === targetWorkout.groupUuid) return;
    if (targetWorkout.stateType === "COMPLETED") {
      notificationHandler.error("לא ניתן להזיז לאימון שהושלם");
      return;
    }

    // Look up source workout for the notification label
    const blocks = planState.plan.blocks.sort((a, b) => a.index > b.index ? 1 : -1);
    const curBlock = blocks.at(planState.blockIdx);
    const curWeek = curBlock?.weeks?.sort((a, b) => a.index > b.index ? 1 : -1).at(planState.weekIdx);
    const sortedWorkouts = curWeek?.workouts?.sort((a, b) => a.index > b.index ? 1 : -1) || [];
    const sourceIdxDisplay = sortedWorkouts.findIndex(w => w.groupUuid === draggedGroupUuid) + 1;
    const targetIdxDisplay = sortedWorkouts.findIndex(w => w.groupUuid === targetWorkout.groupUuid) + 1;
    const movedUuid = draggedGroupUuid;

    setLoading(true);
    moveWorkoutDay(planState.plan.id, draggedGroupUuid, targetWorkout.index, curWeek?.id)
      .then((res) => {
        notificationHandler.success(
          `אימון ${sourceIdxDisplay} הועבר למיקום ${targetIdxDisplay} (${res.data.weeksModified} שבועות עודכנו)`
        );
        setRecentlyMovedGroupUuid(movedUuid);
        setTimeout(() => setRecentlyMovedGroupUuid(null), 1800);
        fetchPlan();
      })
      .catch(e => notificationHandler.error(getErrorMessage(e.response?.data?.errorCode) || "שגיאה בהזזת יום אימון"))
      .finally(() => {
        setLoading(false);
        setDraggedGroupUuid(null);
        setDragOverIndex(null);
      });
  };

  const confirmRemoveWorkoutDay = () => {
    if (!planState?.plan?.id || workoutToRemove === null) return;

    setRemoveWorkoutDialogOpen(false);
    setLoading(true);
    removeWorkoutDay(planState.plan.id, workoutToRemove?.groupUuid, workoutToRemove?.index)
      .then((res) => {
        notificationHandler.success(`יום אימון הוסר בהצלחה (${res.data.weeksModified} שבועות עודכנו)`);
        // Reset active tab if we removed the currently active workout
        if (activeTab > res.data.newNumberOfWorkouts) {
          setActiveTab(res.data.newNumberOfWorkouts);
        }
        fetchPlan();
      })
      .catch(e => notificationHandler.error(getErrorMessage(e.response?.data?.errorCode) || "שגיאה בהסרת יום אימון"))
      .finally(() => {
        setLoading(false);
        setWorkoutToRemove(null);
      });
  };

  const canRemoveWorkout = () => {
    const blocks = planState?.plan?.blocks?.sort((a, b) => a.index > b.index ? 1 : -1);
    const curBlock = blocks?.at(planState?.blockIdx);
    const curWeek = curBlock?.weeks?.sort((a, b) => a.index > b.index ? 1 : -1).at(planState?.weekIdx);
    return curWeek?.workouts?.length > 1 && !curWeek?.finished;
  };

  const canAddWorkout = () => {
    const blocks = planState?.plan?.blocks?.sort((a, b) => a.index > b.index ? 1 : -1);
    const curBlock = blocks?.at(planState?.blockIdx);
    const curWeek = curBlock?.weeks?.sort((a, b) => a.index > b.index ? 1 : -1).at(planState?.weekIdx);
    return curWeek && !curWeek.finished && (curWeek.workouts?.length || 0) < 7;
  };

  // The workout backing the currently-selected tab (activeTab is 1-based).
  const getActiveWorkout = () => {
    const blocks = planState?.plan?.blocks?.sort((a, b) => a.index > b.index ? 1 : -1);
    const curBlock = blocks?.at(planState?.blockIdx);
    const curWeek = curBlock?.weeks?.sort((a, b) => a.index > b.index ? 1 : -1).at(planState?.weekIdx);
    const workouts = curWeek?.workouts?.sort((a, b) => a.index > b.index ? 1 : -1);
    return workouts?.[activeTab - 1] || null;
  };

  // startDate/endDate arrive as epoch SECONDS representing a true UTC instant — the server
  // does not pre-localize them. Passing no timeZone below is deliberate: the browser renders
  // in the coach's own zone, so a coach abroad sees their local wall-clock rather than Israel's.
  const fmtWorkoutDate = (epochSecs) => {
    if (!epochSecs) return null;
    const d = new Date(epochSecs * 1000);
    return d.toLocaleString("he-IL", {
      day: "numeric", month: "numeric", hour: "2-digit", minute: "2-digit",
    });
  };

  if (isMobile) {
    return (
      <MobileClientWeekView
        planState={planState}
        setPlanState={setPlanState}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        editMode={editMode}
        setEditMode={setEditMode}
        openIntervals={openIntervals}
        setOpenIntervals={setOpenIntervals}
        reloadKey={reloadKey}
        setReloadKey={setReloadKey}
        loading={loading}
        setLoading={setLoading}
        newNote={newNote}
        setNewNote={setNewNote}
        handleNewNote={handleNewNote}
        handleForward={handleForward}
        handleBackwards={handleBackwards}
        params={params}
        navigate={navigate}
        notificationHandler={notificationHandler}
        fetchPlan={fetchPlan}
      />
    );
  }

  return (
      <Box sx={{padding: { xs: "12px", md: "20px" }, direction: "rtl"}}>
        <Loader loading={loading}/>
        <NoteDialog approve={handleNewNote} close={() => setNewNote(false)} isOpen={newNote} />
        {client && (
          <ProgramSettingsDialog
            client={client}
            program={planState?.plan}
            handleReload={fetchPlan}
            isOpen={settingsDialogOpen}
            close={() => setSettingsDialogOpen(false)}
          />
        )}

        {planState?.plan?.id && (
          <ProgramWarmupDialog
            program={planState.plan}
            handleReload={fetchPlan}
            isOpen={warmupDialogOpen}
            close={() => setWarmupDialogOpen(false)}
          />
        )}

        <RenameWorkoutDayDialog
          open={!!workoutToRename}
          onClose={() => setWorkoutToRename(null)}
          programId={planState?.plan?.id}
          workout={workoutToRename?.workout ?? null}
          position={workoutToRename?.position ?? 1}
          onRenamed={(nameHeb) => {
            setWorkoutToRename(null);
            notificationHandler.success(`שם יום האימון שונה ל"${nameHeb}"`);
            fetchPlan();
          }}
          onError={(message) => notificationHandler.error(message)}
        />

        {/* Remove Workout Day Confirmation Dialog */}
        <Dialog open={removeWorkoutDialogOpen} onClose={() => setRemoveWorkoutDialogOpen(false)} dir="rtl">
          <DialogTitle>הסרת יום אימון</DialogTitle>
          <DialogContent>
            <DialogContentText>
              האם אתה בטוח שברצונך להסיר את יום האימון הזה? פעולה זו תסיר את יום האימון מכל השבועות שטרם הושלמו.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setRemoveWorkoutDialogOpen(false)}>ביטול</Button>
            <Button onClick={confirmRemoveWorkoutDay} color="error" autoFocus>
              הסר
            </Button>
          </DialogActions>
        </Dialog>

        {/* Header Row - Back button + Title + Add Notes */}
        <Box sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: { xs: "12px", md: "16px" }
        }}>
          {/* Right side - Back button + Title */}
          <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1, md: 2 } }}>
            <IconButton
              onClick={() => navigate(`/app/clients/${params.userId}`)}
              sx={{
                color: "#64748B",
                padding: { xs: "6px", md: "8px" },
                "&:hover": {
                  backgroundColor: "#F1F5F9",
                  color: "#1E293B"
                }
              }}
            >
              <ArrowForward sx={{ fontSize: { xs: "20px", md: "24px" } }} />
            </IconButton>
            <Typography sx={{
              fontSize: { xs: "18px", md: "22px" },
              fontWeight: 700,
              color: "#1E293B"
            }}>
              תוכנית אימונים
            </Typography>
          </Box>

          {/* Left side - Settings + Add Notes */}
          <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1, md: 2 } }}>
            <Tooltip title="סקירת שבוע" arrow>
              <IconButton
                onClick={() => navigate(`/app/clients/${params.userId}/${params.programId}/week/${planState?.blockIdx ?? params.blockIndex}/${planState?.weekIdx ?? params.weekIndex}/overview`)}
                sx={{
                  color: "#64748B",
                  padding: { xs: "6px", md: "8px" },
                  "&:hover": {
                    backgroundColor: "#F1F5F9",
                    color: "#1E293B"
                  }
                }}
              >
                <OverviewIcon sx={{ fontSize: { xs: "18px", md: "20px" } }} />
              </IconButton>
            </Tooltip>
            <IconButton
              onClick={() => setSettingsDialogOpen(true)}
              sx={{
                color: "#64748B",
                padding: { xs: "6px", md: "8px" },
                "&:hover": {
                  backgroundColor: "#F1F5F9",
                  color: "#1E293B"
                }
              }}
            >
              <SettingsIcon sx={{ fontSize: { xs: "18px", md: "20px" } }} />
            </IconButton>
            <Tooltip title="טקסט חימום">
              <IconButton
                onClick={() => setWarmupDialogOpen(true)}
                sx={{
                  color: "#64748B",
                  padding: { xs: "6px", md: "8px" },
                  "&:hover": {
                    backgroundColor: "#F1F5F9",
                    color: "#1E293B"
                  }
                }}
              >
                <WarmupIcon sx={{ fontSize: { xs: "18px", md: "20px" } }} />
              </IconButton>
            </Tooltip>
            <Box
              onClick={() => setNewNote(true)}
              sx={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: { xs: "4px", md: "6px" },
                color: "#64748B",
                transition: "all 0.2s",
                "&:hover": {
                  color: "#1E293B"
                }
              }}
            >
              <NoteAdd sx={{fontSize: { xs: "18px", md: "20px" }}} />
              <Typography sx={{
                fontSize: { xs: "11px", md: "13px" },
                fontWeight: 600,
                display: { xs: "none", sm: "block" }
              }}>הוסף הערה</Typography>
            </Box>
          </Box>
        </Box>

        {/* Week Navigation Row */}
        {planState && (
          <Box sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: "12px", md: "16px" },
            marginBottom: { xs: "12px", md: "16px" },
            padding: { xs: "8px 0", md: "10px 0" }
          }}>
            <IconButton
              disabled={editMode}
              onClick={handleBackwards}
              sx={{
                color: editMode ? "#CBD5E1" : "#64748B",
                padding: { xs: "6px", md: "8px" },
                backgroundColor: "#F8FAFC",
                border: "1px solid #E2E8F0",
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "#F1F5F9",
                  color: "#1E293B"
                },
                "&:disabled": {
                  backgroundColor: "#F8FAFC",
                  borderColor: "#E2E8F0"
                }
              }}
            >
              <ArrowForward sx={{fontSize: { xs: "18px", md: "20px" }}} />
            </IconButton>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography sx={{
                fontSize: { xs: "14px", md: "16px" },
                fontWeight: 600,
                color: "#1E293B",
                whiteSpace: "nowrap",
                minWidth: { xs: "120px", md: "150px" },
                textAlign: "center"
              }}>
                בלוק {Number(planState.blockIdx) + 1} / שבוע {Number(planState.weekIdx) + 1}
              </Typography>
              {(() => {
                const blocks = planState.plan?.blocks?.sort((a, b) => a.index > b.index ? 1 : -1);
                const curBlock = blocks?.at(planState.blockIdx);
                const curWeek = curBlock?.weeks?.sort((a, b) => a.index > b.index ? 1 : -1).at(planState.weekIdx);

                if (curWeek?.manipulationVersion) {
                  return (
                    <Tooltip
                      // manipulationRunAt is epoch MILLIS — ProgramMapper emits it with
                      // Instant.toEpochMilli(), unlike startDate/endDate a few lines up which are
                      // epoch SECONDS and therefore need the * 1000. Do NOT "fix" this by adding
                      // one: that would render the year ~58500. The generated type is a bare
                      // `number` and cannot express the difference, which is why it is stated here.
                      title={curWeek.manipulationRunAt
                        ? `Last run: ${new Date(curWeek.manipulationRunAt).toLocaleString('he-IL')}`
                        : ''
                      }
                      arrow
                    >
                      <Chip
                        label={`v${curWeek.manipulationVersion}`}
                        size="small"
                        sx={{
                          fontSize: '11px',
                          height: '20px',
                          backgroundColor: '#E2E8F0',
                          color: '#64748B',
                          fontWeight: 500
                        }}
                      />
                    </Tooltip>
                  );
                }
                return null;
              })()}
            </Box>

            <IconButton
              disabled={editMode}
              onClick={handleForward}
              sx={{
                color: editMode ? "#CBD5E1" : "#64748B",
                padding: { xs: "6px", md: "8px" },
                backgroundColor: "#F8FAFC",
                border: "1px solid #E2E8F0",
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "#F1F5F9",
                  color: "#1E293B"
                },
                "&:disabled": {
                  backgroundColor: "#F8FAFC",
                  borderColor: "#E2E8F0"
                }
              }}
            >
              <ArrowBack sx={{fontSize: { xs: "18px", md: "20px" }}} />
            </IconButton>
          </Box>
        )}

        {/* Workout Tabs - Scrollable on mobile */}
        {planState && planState.plan?.blocks && (
          <Box sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            marginBottom: { xs: "12px", md: "20px" },
            overflowX: "auto",
            // Vertical padding gives the pills' hover lift (translateY(-1px)) and
            // focus/shadow room so the top edge isn't clipped by overflowX: auto.
            py: "6px",
            WebkitOverflowScrolling: "touch",
            "&::-webkit-scrollbar": {
              display: "none"
            },
            msOverflowStyle: "none",
            scrollbarWidth: "none",
            mx: { xs: -1.5, md: 0 },
            px: { xs: 1.5, md: 0 }
          }}>
            {/* Remove Workout Day Button */}
            {canRemoveWorkout() && !editMode && (
              <Tooltip title="הסר יום אימון" arrow>
                <IconButton
                  onClick={() => {
                    const blocks = planState.plan.blocks.sort((a, b) => a.index > b.index ? 1 : -1);
                    const curBlock = blocks.at(planState.blockIdx);
                    const curWeek = curBlock?.weeks?.sort((a, b) => a.index > b.index ? 1 : -1).at(planState.weekIdx);
                    const workouts = curWeek?.workouts?.sort((a, b) => a.index > b.index ? 1 : -1);
                    const currentWorkout = workouts?.[activeTab - 1];
                    if (currentWorkout && currentWorkout.stateType !== "COMPLETED") {
                      handleRemoveWorkoutDay(currentWorkout);
                    } else {
                      notificationHandler.error("לא ניתן להסיר אימון שהושלם");
                    }
                  }}
                  sx={{
                    color: "#EF4444",
                    padding: "6px",
                    backgroundColor: "#FEF2F2",
                    border: "1px solid #FECACA",
                    borderRadius: "8px",
                    "&:hover": {
                      backgroundColor: "#FEE2E2",
                      color: "#DC2626"
                    }
                  }}
                >
                  <RemoveIcon sx={{ fontSize: "18px" }} />
                </IconButton>
              </Tooltip>
            )}

            {(() => {
              const blocks = planState.plan.blocks.sort((a, b) => a.index > b.index ? 1 : -1);
              const curBlock = blocks.at(planState.blockIdx);
              if (!curBlock?.weeks) return null;

              const weeks = curBlock.weeks.sort((a, b) => a.index > b.index ? 1 : -1);
              const curWeek = weeks.at(planState.weekIdx);
              if (!curWeek?.workouts) return null;

              const canReorder = !editMode && !curWeek.finished;
              const sortedWorkouts = [...curWeek.workouts].sort((a, b) => a.index > b.index ? 1 : -1);

              return sortedWorkouts.map((workout, index) => {
                const isSelf = draggedGroupUuid === workout.groupUuid;
                const isValidTarget = !!draggedGroupUuid && !isSelf && workout.stateType !== "COMPLETED";
                return (
                  <ClientWorkoutChip
                    disable={editMode}
                    key={workout.groupUuid || index}
                    setActiveTab={setActiveTab}
                    index={index + 1}
                    label={workout.customName ? workoutDayLabel(workout, index + 1) : undefined}
                    active={activeTab === index + 1}
                    isCompleted={workout.stateType === "COMPLETED"}
                    stateType={workout.stateType}
                    draggable={canReorder}
                    isDragOver={dragOverIndex === index && isValidTarget}
                    isDragging={isSelf}
                    isValidDropTarget={isValidTarget}
                    isJustMoved={recentlyMovedGroupUuid === workout.groupUuid}
                    onDragStart={() => setDraggedGroupUuid(workout.groupUuid)}
                    onDragOver={() => isValidTarget && setDragOverIndex(index)}
                    onDragLeave={() => setDragOverIndex((prev) => (prev === index ? null : prev))}
                    onDragEnd={() => { setDraggedGroupUuid(null); setDragOverIndex(null); }}
                    onDrop={() => isValidTarget && handleWorkoutDrop(workout)}
                  />
                );
              });
            })()}

            {/* Rename Workout Day Button — acts on the active tab, like remove */}
            {!editMode && (
              <Tooltip title="שנה שם יום אימון" arrow>
                <IconButton
                  aria-label="שנה שם יום אימון"
                  onClick={() => {
                    const blocks = planState.plan.blocks.sort((a, b) => a.index > b.index ? 1 : -1);
                    const curBlock = blocks.at(planState.blockIdx);
                    const curWeek = curBlock?.weeks?.sort((a, b) => a.index > b.index ? 1 : -1).at(planState.weekIdx);
                    const workouts = curWeek?.workouts?.sort((a, b) => a.index > b.index ? 1 : -1);
                    const currentWorkout = workouts?.[activeTab - 1];
                    if (currentWorkout) setWorkoutToRename({workout: currentWorkout, position: activeTab});
                  }}
                  sx={{
                    color: "#475569",
                    padding: "6px",
                    backgroundColor: "#F8FAFC",
                    border: "1px solid #E2E8F0",
                    borderRadius: "8px",
                    "&:hover": {
                      backgroundColor: "#F1F5F9",
                      color: "#1E293B"
                    }
                  }}
                >
                  <RenameIcon sx={{ fontSize: "18px" }} />
                </IconButton>
              </Tooltip>
            )}

            {/* Add Workout Day Button */}
            {canAddWorkout() && !editMode && (
              <Tooltip title="הוסף יום אימון" arrow>
                <IconButton
                  onClick={handleAddWorkoutDay}
                  sx={{
                    color: "#10B981",
                    padding: "6px",
                    backgroundColor: "#ECFDF5",
                    border: "1px solid #A7F3D0",
                    borderRadius: "8px",
                    "&:hover": {
                      backgroundColor: "#D1FAE5",
                      color: "#059669"
                    }
                  }}
                >
                  <AddIcon sx={{ fontSize: "18px" }} />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        )}

        {/* Active workout start / completed dates (only shown once the trainee has started it) */}
        {planState && (() => {
          const w = getActiveWorkout();
          const started = fmtWorkoutDate(w?.startDate);
          const completed = fmtWorkoutDate(w?.endDate);
          if (!started && !completed) return null;
          return (
            <Box sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: { xs: "6px", md: "14px" },
              marginBottom: { xs: "10px", md: "14px" },
              fontSize: { xs: "11px", md: "12.5px" },
              color: "#64748B",
            }}>
              {started && (
                <Box sx={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
                  התחיל:
                  <Box component="span" sx={{ fontWeight: 600, color: "#1E293B", direction: "ltr" }}>{started}</Box>
                </Box>
              )}
              {completed && (
                <Box sx={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
                  הושלם:
                  <Box component="span" sx={{ fontWeight: 600, color: "#059669", direction: "ltr" }}>{completed}</Box>
                </Box>
              )}
            </Box>
          );
        })()}

        {/* Weekly Summary - Now at the top for quick overview */}
        {planState && <WeekMusclesBreakdown planState={planState} reloadKey={reloadKey} />}

        {/* Workout Table */}
        {planState && (
          <Box sx={{marginTop: { xs: "12px", md: "20px" }}}>
            <WorkoutActiveTab
              setLoading={setLoading}
              traineeId={params.userId}
              editMode={editMode}
              setEditMode={setEditMode}
              workoutIdx={activeTab-1}
              planState={planState}
              openIntervals={openIntervals}
              setOpenIntervals={setOpenIntervals}
              onReload={() => {
                setReloadKey(prev => prev + 1);
                fetchPlan();
              }}
            />
          </Box>
        )}
      </Box>
  )
};

export default ClientWeekPage;
